import { NgModule, Optional, SkipSelf } from '@angular/core';
import { PcConfirmationModule } from 'app/shared/services/confirmation';
import { PcLoadingModule } from 'app/shared/services/loading';
import { PcMediaWatcherModule } from 'app/shared/services/media-watcher/media-watcher.module';
import { PcPlatformModule } from 'app/shared/services/platform/platform.module';
import { PcUtilsModule } from 'app/shared/services/utils/utils.module';

@NgModule({
  imports: [
    PcConfirmationModule,
    PcLoadingModule,
    PcMediaWatcherModule,
    PcPlatformModule,
    PcUtilsModule,
  ],
})
export class PcModule {
  /**
   * Constructor
   */
  constructor(@Optional() @SkipSelf() parentModule?: PcModule) {
    if (parentModule) {
      throw new Error(
        'PcModule has already been loaded. Import this module in the AppModule only!'
      );
    }
  }
}
